export default __webpack_public_path__ + "static/media/Leggings of the Refectory.90f45f0f.jpg";